import dayjs from 'dayjs'
import { declOfNum } from './declOfNum'

export const billingProductName = (product) => product.target_type === 'class'
  ? `Класс: ${product.name || (product.label || '').replace(/^Класс:\s*/, '')}`
  : product.name || product.label

export const billingPeriodLabel = (unit, value, from, until) => {
  if (unit === 'dates') return from && until ? `${dayjs(from).format('DD.MM.YYYY')} — ${dayjs(until).format('DD.MM.YYYY')}` : ''
  const titles = { lessons: ['занятие', 'занятия', 'занятий'], months: ['месяц', 'месяца', 'месяцев'], weeks: ['неделя', 'недели', 'недель'], days: ['день', 'дня', 'дней'] }
  return value > 0 && titles[unit] ? `${value} ${declOfNum(value, titles[unit])}` : ''
}

export const billingSuggestedAmount = (product, unit, value, from, until) => {
  if (!product) return 0
  const count = unit === 'dates' ? dayjs(until).diff(dayjs(from), 'day') + 1 : Number(value)
  if (!Number.isFinite(count) || count <= 0 || (unit === 'dates' && (!from || !until))) return 0
  const exact = product.period_prices?.find((period) => period.unit === unit && Number(period.value) === count)
  if (exact) return Number(exact.amount)
  const price = Number(product.suggested_amount || 0)
  if (unit === 'lessons') return Math.round(price * count * 100) / 100
  const factors = { months: 30, weeks: 7, days: 1, dates: 1 }
  const days = count * factors[unit]
  const closest = product.period_prices?.reduce((best, period) => {
    const periodDays = Number(period.value) * factors[period.unit]
    return !best || Math.abs(periodDays - days) < Math.abs(best.days - days) ? { days: periodDays, amount: Number(period.amount) } : best
  }, null)
  return Math.round((closest?.amount ?? price) * days / (closest?.days || product.price_period_days || 30) * 100) / 100
}

export const billingServiceDescription = (product, unit, value, from, until) => {
  const period = billingPeriodLabel(unit, value, from, until)
  if (!product || !period) return ''
  return `Оплата обучения по ${product.target_type === 'class' ? 'классу' : 'курсу'} «${product.name || product.label}» за ${period}`
}
